import React, { Component } from 'react';
import classNames from 'classnames';
import { StaticContents } from 'components/ServerSideComponents.jsx';
import urlName from './url-name';
import { imagePath, root1002019LogoBlack, rootIcon } from './components/images';
import styles from './scss/index.scss';
import removeMarkdown from 'remove-markdown';

export const defaultPageTitle = 'The Root 100 Most Influential African Americans 2019 | TheRoot.com';

export default class App extends Component {
	render() {
		const entry = this.props.data && this.props.data.items.find(item => item.sys.id === this.props.id);
		const description = entry ? removeMarkdown(entry.fields.claimToFame) : `The Root's annual list of the most influential African
      Americans in the fields of arts, community, business, entertainment, media,
      politics, science and sports.`;

		const path = entry ? urlName(entry.fields.name) : '';
		const title = entry ? entry.fields.name : 'The Root 100 - The Most Influential African Americans In 2019';
		const url = `https://interactives.kinja.com/theroot/root-100-2019/${path}`;
		const shareBaseUrl = 'https://interactives.kinja.com';
		const image = entry ? entry.fields.imageUrl : `${shareBaseUrl}${imagePath}${root1002019LogoBlack}`;
		const pageTitle = entry ? `${entry.fields.name} | ${defaultPageTitle}` : defaultPageTitle;

		return (
      <html>
      <head>
        <title>{pageTitle}</title>
        <meta charset='UTF-8' name='Content-Type' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <meta property='og:site_name' content='The Root' />
        <meta property='fb:app_id' content='216290255435043'/>
        <meta property='fb:pages' content='26423400230' />
        <meta property='og:title' content={title} />
        <meta property='og:type' content='blog' />
        {/* <meta property='og:url' content={url} /> */}
        <meta property='og:description' content={description} />
        <meta property='og:image' content={image} />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:url' content={url} />
        <meta name='twitter:title' content={title} />
        <meta name='twitter:description' content={description} />
        <meta name='twitter:image' content={image} />
        <link href='https://fonts.googleapis.com/css?family=Asap:400,500|Nova+Round' rel='stylesheet'></link>
        <link href={`${imagePath}${rootIcon}`} rel='shortcut icon' type='image/jpg' />
      </head>
      <body>
        <div id='root'>
          <StaticContents>
            <div className={styles.skCubeGridWrap}>
              <div className={styles.skCubeGrid}>
                <div className={classNames(styles.skCube, styles.skCube1)} />
                <div className={classNames(styles.skCube, styles.skCube2)} />
                <div className={classNames(styles.skCube, styles.skCube3)} />
                <div className={classNames(styles.skCube, styles.skCube4)} />
                <div className={classNames(styles.skCube, styles.skCube5)} />
                <div className={classNames(styles.skCube, styles.skCube6)} />
                <div className={classNames(styles.skCube, styles.skCube7)} />
                <div className={classNames(styles.skCube, styles.skCube8)} />
                <div className={classNames(styles.skCube, styles.skCube9)} />
              </div>
            </div>
          </StaticContents>
        </div>
        <div id='trackers' />
      </body>
      </html>
		);
	}
}



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/template.js